import { MutationCache, QueryCache, QueryClient, type QueryKey } from '@tanstack/react-query'

import { isApiError } from '@/shared/api/problem'

interface CreateQueryClientOptions {
  /** Chamado quando qualquer requisição recebe 401 (sessão expirada). */
  onUnauthenticated: (queryKey?: QueryKey) => void
}

export function createQueryClient({ onUnauthenticated }: CreateQueryClientOptions): QueryClient {
  const handleError = (error: unknown, queryKey?: QueryKey) => {
    if (isApiError(error) && error.status === 401) {
      onUnauthenticated(queryKey)
    }
  }

  return new QueryClient({
    queryCache: new QueryCache({
      onError: (error, query) => handleError(error, query.queryKey),
    }),
    mutationCache: new MutationCache({
      onError: (error) => handleError(error),
    }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        // Erros 4xx são definitivos; só repete falhas de rede/5xx.
        retry: (failureCount, error) =>
          !(isApiError(error) && error.status >= 400 && error.status < 500) && failureCount < 2,
      },
    },
  })
}
